const DotIcon = ({ className }) => {
  return (
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 5.19995C0 2.43853 2.23858 0.199951 5 0.199951C7.76142 0.199951 10 2.43853 10 5.19995C10 7.96137 7.76142 10.2 5 10.2C2.23858 10.2 0 7.96137 0 5.19995Z"
        fill="#F3F4F6"
      />
    </svg>
  );
};

export default DotIcon;
